<template>
  <div class="MenuMain" direction="vertical">
    <el-container>      
      <el-main>
        <el-row>
          <h1 :style="{fontSize:'3vh',color:'#303133'}">请选择抽签方式</h1>
        </el-row>
       <el-row type="flex" justify="center" :style="{marginTop:'10vh'}">
           <el-col :span="4"><el-button type="primary" @click="gotoPickQu()">按点位抽签</el-button></el-col>
           <el-col :span="4" :offset="1"><el-button type="primary">按人员抽签</el-button></el-col>
       </el-row>
      </el-main>
    </el-container>
  </div>
</template>
<style>
.MenuMain{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /*设置内部填充为0，几个布局元素之间没有间距*/
  padding: 0px;
  /*外部间距也是如此设置*/
  margin: 0px;
  /*统一设置高度为100%*/
  height: 100%;

  background-color: #EBEEF5;

}

.el-button{
  width:100%;
  height: 20vh;
  font-size: 3vh !important;
}

.el-main{
    padding: 0px !important;
    
}
</style>
<script>
export default {
  mounted:function(){
    //router.push("cjIndex/mainp");
  },
  methods:{
    gotoPickQu(){
      this.$router.push("cjIndex/pickqu");
    }
  }
}
</script>